import { useNavigate } from "react-router-dom";
import useFetch from "@/lib/useFetch";
import { PageHeader, Loading, ErrorState, EmptyState, Avatar } from "@/components/common";
import { brl, pct, num } from "@/lib/format";
import { Trophy, Medal } from "@/components/icons";

const medal = ["text-gold", "text-slate-400", "text-amber-700"];

export default function Desempenho() {
  const navigate = useNavigate();
  const { data, loading, error, reload } = useFetch("/desempenho");
  if (loading) return <Loading />;
  if (error) return <ErrorState onRetry={reload} />;
  const list = Array.isArray(data) ? data : (data?.ranking || []);
  // R-2 (item 2): rótulo do período vem dentro de cada item (ou mês atual se
  // a lista vier vazia). Mantém a resposta como lista — zero regressão de API.
  const periodoLabel = (list[0]?.periodo_label) || (() => {
    const d = new Date();
    const m = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"][d.getMonth()];
    return `${m}/${d.getFullYear()}`;
  })();
  const subtitle = (list.some((m) => m.tiebreaker_ativo)
    ? "Ranking por Realizado (faturamento oficial) — empate por previsão ponderada, depois oportunidades"
    : "Ranking por Realizado (faturamento oficial)")
    + ` · ${periodoLabel}`;

  return (
    <div>
      <PageHeader title="Desempenho" subtitle={subtitle} />
      {list.length === 0 ? (
        <EmptyState icon={Trophy} title="Sem dados de desempenho" subtitle="Nenhum vendedor no seu escopo ainda." />
      ) : (
        <div className="space-y-3">
          {list.map((m, i) => {
            // Item 2.2 — troféu apenas para quem tem Realizado > 0.
            const podium = i < 3 && (m.revenue || 0) > 0;
            // R-2 (item 2): conversão = null (sem encerrados no período) → "—".
            const convLabel = m.conversion == null ? "—" : pct(m.conversion, 0);
            return (
              <div key={m.id} onClick={() => navigate(`/membro/${m.id}`)} data-testid={`rank-${m.id}`}
                className="bg-card rounded-xl border border-black/5 p-4 flex items-center gap-4 cursor-pointer hover:bg-slate-50 transition-colors shadow-[0_2px_10px_rgb(0,0,0,0.03)]">
                <div className="w-8 text-center shrink-0">
                  {podium ? <Medal className={`w-6 h-6 mx-auto ${medal[i]}`} /> : <span className="text-lg font-bold text-slate-300">{i + 1}</span>}
                </div>
                <Avatar name={m.nome} src={m.avatar} size={42} />
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-navy truncate">{m.nome}</div>
                  <div className="text-xs text-muted-foreground truncate">{m.gestor_nome ? `Gestor: ${m.gestor_nome}` : m.cargo} · {num(m.deals)} op. · <span title="Ganhas ÷ (Ganhas + Perdidas) fechadas no período × 100">{convLabel} conv.</span></div>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-semibold text-navy" title="Realizado (faturamento oficial)">{brl(m.revenue)}</div>
                  <div className="text-[11px] text-muted-foreground">Ganho no CRM: {brl(m.won_value || 0)}</div>
                  <div className="text-xs text-muted-foreground">meta {pct(m.achievement)}</div>
                  {m.tiebreaker_ativo && <div className="text-[11px] text-muted-foreground">prev. pond. {brl(m.previsao_ponderada)}</div>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
